<div *ngIf="!isSupported" class="warning">
    <h1>You are using an unsupported browser!</h1>
    <h4>We do not support Internet Explorer or Edge.</h4>
    <h4>Please navigate to CLARK in another browser.</h4>
    <h4>See you soon!</h4>
</div>
